import { createContext } from 'react';
import { TransactionsHistoryHostProps } from './types';

export const TransactionHistoryContext = createContext<TransactionsHistoryHostProps | null>(null);
